import dayjs from 'dayjs';

const formatDate = (dateStr: string | null): string | null => {
  return dateStr ? dayjs(dateStr).format('DD.MM.YYYY') : dateStr;
};

export default formatDate;
